import React, { useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const ReusableDropdown = ({ options, parentId }) => {
  const [visible, setVisible] = useState(false);

  const handleShowDropDownOptions = () => {
    setVisible(true);
  };

  const handleCloseOptions = () => {
    setVisible(false);
  };

  const handleOptionClick = (option) => {
    option.onClick(parentId);
    handleCloseOptions();
  };

  const menu = (
    <Menu>
      {options.map((option, index) => (
        <Menu.Item key={index} onClick={() => handleOptionClick(option)}>
          {option.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div>
      <Dropdown
        overlay={menu}
        visible={visible}
        onVisibleChange={(flag) => setVisible(flag)}
      >
        <Button onClick={handleShowDropDownOptions}>
           <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );
};

export default ReusableDropdown;

